import * as React from 'react';

const MegaphoneRegularSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={48} height={48} fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M36.007 28.238v-8.476c2 .009 3.986 1.905 3.986 4.238 0 2.332-1.986 4.229-3.986 4.238zm-2 9.132l-18-8.857v-9.279l18-8.71V37.37zm-26-9.37h6v-8h-6v8zm33.986-4c0-3.435-2.986-6.23-5.986-6.239V6h-2v2.295l-20 9.705h-8v12h4v6h2v-6h2.467l19.533 9.606V42h2V30.239c3-.009 5.986-2.804 5.986-6.239z"
            fill="#39364F"
        />
    </svg>
);

MegaphoneRegularSvg.displayName = 'MegaphoneRegularSvg';
export default MegaphoneRegularSvg;
